var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeroneDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.604 14H13v6.604h6.604V14z",
    fill: "#009C4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.694 14H22.09v6.604h6.604V14z",
    fill: "#00D064"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.784 14h-6.603v6.604h6.603V14z",
    fill: "#33D982"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.604 39.64H13v6.604h6.604V39.64z",
    fill: "#009C4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.694 39.64H22.09v6.604h6.604V39.64z",
    fill: "#00D064"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.784 39.64h-6.603v6.604h6.603V39.64z",
    fill: "#33D982"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.604 27.085H13v6.604h6.604v-6.604z",
    fill: "#009C4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.694 27.085H22.09v6.604h6.604v-6.604z",
    fill: "#98ECC0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.784 27.085h-6.603v6.604h6.603v-6.604z",
    fill: "#00D064"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.63 27.085h-6.604v6.604h6.604v-6.604z",
    fill: "#98ECC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroneDataIcon);
export default __webpack_public_path__ + "static/media/zerone-data-icon.f059b5c6be8a4a2de5a3c1494c0bc415.svg";
export { ForwardRef as ReactComponent };